var BaseView = require('./abstract/template');
var thumbIndex = 0;

module.exports = BaseView.extend({
  width: null,
  height: null,
  setCurrentPage: false,
  template: require('./templates/grid.hbs'),
  designAddedEvent: 'template.update.grid',

  initialize: function (options) {
    BaseView.prototype.initialize.call(this);

    this.setCurrentPage = options.setCurrentPage;
    this.size = options.size;
    this.format = options.format;
    this.numberOfPhotos = options.numberOfPhotos;

    this.processSVGData(options.data);
    this.render();
  },

  getTemplateRenderData: function () {
    return {
      defs: this.defs,
      content: this.svg,
      width: this.size.width,
      height: this.size.height
    };
  },

  processSVGData: function (data) {
    thumbIndex++;

    this.defs = replaceOwnIds(data.defs);
    this.svg = replaceImages(data.svg, data.defs);
    this.svg = replaceOwnIds(this.svg);
    this.svg = replaceClipPaths(this.svg);
    this.name = data.name;

    function replaceImages (str, defs) {
      INKIVE.SVGPlaceholderImage.setClipsData(defs);
      var imageExp = /<image xmlns:xlink="[^"]*" id="([^"]*)" clip-path="url\(#([^"]*)\)" [^>]*">[^<]*<\/image>/g;
      return str.replace(imageExp, function (prev, id, clipId) {
        var svgPlaceholder = INKIVE.SVGPlaceholderImage.render(id, clipId);
        return svgPlaceholder ? svgPlaceholder.svgString : prev;
      });
    }

    function replaceOwnIds (str) {
      return str.replace(/id="(.*?)"/g, 'id="$1-thumb-' + thumbIndex + '"');
    }

    function replaceClipPaths (str) {
      return str.replace(/clip-path="url\(#(.*?)\)"/g, 'clip-path="url(#$1-thumb-' + thumbIndex + ')"');
    }
  },

  setTemplate: function () {
    BaseView.prototype.setTemplate.apply(this, arguments);

    INKIVE.DesignFacade.set('template', {
      size: this.format,
      setCurrentPage: this.setCurrentPage,
      grid: {
        'index_in_set': this.name,
        'number_of_photos': this.numberOfPhotos
      }
    });
  },

  isSameSize: function () {
    return this.canvas.contentW == this.format['width']
      && this.canvas.contentH == this.format['height'];
  }
});
